var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"max-winners-instruction"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showInstructions),expression:"showInstructions"}],staticClass:"alert alert-primary",attrs:{"role":"alert"}},[_c('h4',{staticClass:"alert-heading"},[_vm._v("Please vote for up to "+_vm._s(_vm.maxWinners))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }